import React, { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import MaterialTable from 'material-table'
import { usersTableStyles } from './users-table.styles'
import { useSelector } from 'react-redux'
import { UsersTableConstants } from './users-table.constants'
import { useUsersContext } from '../../contexts'

const localization = (formatMessage) => ({
  pagination: {
    labelDisplayedRows: formatMessage({ id: 'pagination.labelDisplayedRows' }),
    labelRowsSelect: formatMessage({ id: 'pagination.labelRowsSelect' }),
    firstAriaLabel: formatMessage({ id: 'pagination.firstAriaLabel' }),
    firstTooltip: formatMessage({ id: 'pagination.firstTooltip' }),
    previousAriaLabel: formatMessage({ id: 'pagination.previousAriaLabel' }),
    previousTooltip: formatMessage({ id: 'pagination.previousTooltip' }),
    nextAriaLabel: formatMessage({ id: 'pagination.nextAriaLabel' }),
    nextTooltip: formatMessage({ id: 'pagination.nextTooltip' }),
    lastAriaLabel: formatMessage({ id: 'pagination.lastAriaLabel' }),
    lastTooltip: formatMessage({ id: 'pagination.lastTooltip' }),
  },
  body: {
    emptyDataSourceMessage: formatMessage({ id: 'table.body.emptyDataSourceMessage' }),
  },
})

export function UsersTableComponent() {
  const intl = useIntl()
  const { formatMessage } = intl
  const { data, loading } = useUsersContext()
  const language = useSelector((state) => state.global.locale)

  const tableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: false,
      headerStyle: usersTableStyles.header,
      draggable: false,
      pageSize: 10,
    }),
    []
  )

  const formattedColumns = useMemo(
    () =>
      UsersTableConstants.map((column) => ({
        ...column,
        title: formatMessage({ id: `pages.users.table.columns.${column.field}.title` }),
        cellStyle: {
          ...usersTableStyles.cell,
          ...column.cellStyle,
          minWidth: column.width,
        },
        emptyValue: () => <span>--</span>,
      })),
    [language] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return (
    <>
      <MaterialTable
        data={data}
        options={tableOptions}
        columns={formattedColumns}
        isLoading={loading}
        localization={useCallback(localization(formatMessage), [language])} // eslint-disable-line react-hooks/exhaustive-deps
      />
    </>
  )
}
